import React from "react";
import { useLocation } from "react-router-dom";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo, { parentInterface } from "../../../../componets/NavBarTwo";

interface PropsInterface {
  title: string;
  navs: {[index: number]: any};
  parent?: parentInterface;
}

const _PageHeader = ({ title, navs, parent }: PropsInterface) => {
  const { pathname }  = useLocation();
  const activeItem    = Object.values(navs).find(e => e.url === pathname);

  return (
    <PageHeader
      title={title}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={navs}
        itemIds={Object.keys(navs)}
        activeId={activeItem?.id}
        parent={parent}
      />
    </PageHeader>
  );
}

export default _PageHeader;
